import { ResponseWrapper } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';
import useSWRImmutable from 'swr/immutable';
import { SupportedLocale } from '@tlx/intl';

export type LoggedInUserInfoDTO = {
    employeeId: number;
    companyId: number;
    language: SupportedLocale;
};

const refreshInterval = 1000 * 60 * 5; // 5 minutes

export function useUserInfo() {
    const { data } = useSWRImmutable<ResponseWrapper<LoggedInUserInfoDTO>>(APIUrls.WHO_AM_I, {
        refreshInterval,
        refreshWhenHidden: true,
    });
    return {
        companyId: data?.value?.companyId,
        employeeId: data?.value?.employeeId,
        userLanguage: data?.value?.language,
    };
}
